export default __webpack_public_path__ + "static/media/global_bottom1.11d51fe0.png";